import template from './mx-search-query-builder.component.html';
import { EventCodes } from '../../../../App/model/event-codes';

angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryBuilder', {
	bindings: {
		query: '=',
		context: '=',
		parent: '=',
		showInNavigation: '=',
		closeFn: '&',
	},
	controller: MxSearchQueryBuilderCtrl,
	controllerAs: 'vm',
	template: template,
});

MxSearchQueryBuilderCtrl.$inject = [
	'mx.SolutionBuilderAgent.SearchQueryService',
	'mx.SolutionBuilderAgent.SearchQueryGroup',
	'mx.shell.NotificationService',
	'mx.shell.EventService',
	'mx.internationalization',
	'mx.shell.ActionManagerService',
	'mx.SolutionBuilderAgent.PersonalizationService',
];

function MxSearchQueryBuilderCtrl(searchQueryService, SearchQueryGroup, notificationService, eventService, i18n, actionManagerService, personalizationService) {
	const vm = this;

	vm.$onInit = function () {
		vm.ctx = {};
		vm.actions = [];
		vm.canEdit = vm.query.canEdit;

		_fillActions();

		if (vm.query.objectId && vm.query.dataQuery) {
			vm.ctx._type = 'PDRDataQueryFilterType';
			vm.ctx._id = vm.query.objectId;

			actionManagerService
				.getActions(
					new mx.shell.ActionsContext(['PDRDataQueryFilterType'], [], mx.shell.ActionUiZone.SidePanel),
					[mx.shell.ActionContextType.Single, mx.shell.ActionContextType.Multiple],
					[vm.ctx]
				)
				.then(function (actions) {
					if (Array.isArray(actions)) {
						vm.actions = vm.actions.concat(actions.filter((action) => !action.dialogTypes && !action.isService && action.name !== 'Deleteobjects'));
					}
				});
		}

		if (vm.showInNavigation) {
			vm.query.showInNavigation = true;
		}

		vm.query.parent = vm.query.parent || (vm.parent ? vm.parent.id : undefined);
		collapseAll();

		initIsDefault();
	};

	vm.openParent = () => {
		searchQueryService.editFilter(vm.parent);
	};

	vm.saveClick = (event, andClose) => {
		if (!vm.canEdit) {
			if (andClose) {
				vm.closeFn();
			}
			return;
		}

		if (validateQueryBuilder()) {
			clearInvalidConditions(vm.query.group);

			if (vm.query.id) {
				searchQueryService.saveSearchQuery(vm.query, vm.context).then(() => {
					onSearchQuerySaved(andClose);
				});
			} else {
				searchQueryService.addSearchQuery(vm.query, vm.context).then((id) => {
					vm.query.id = id;
					notificationService.success(i18n.get('solutionBuilderAgent.components.mx-search-query-builder.searchQueryAdded'));
					saveAsDefaultFilter();
					eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.SearchQueryAdded, id);

					eventService.dispatchEvent(EventCodes.TrackTelemetry, {
						eventName: `Search Filter created`,
						sender: vm.context?.navigationItem?.id,
						senderTitle: vm.context?.navigationItem?.technicalName,
					});

					if (andClose) {
						vm.closeFn();
					}
				});
			}
		}
	};

	function collapseAll() {
		if (vm.query.group.conditions) {
			vm.query.group.conditions.forEach((c) => {
				c.__expanded = false;
			});
		}

		if (vm.query.group.groups) {
			vm.query.group.groups.forEach((g) => {
				g.conditions.forEach((c) => {
					c.__expanded = false;
				});
			});
		}
	}

	function onSearchQuerySaved(andClose) {
		notificationService.success(i18n.get('solutionBuilderAgent.components.mx-search-query-builder.searchQuerySaved'));
		saveAsDefaultFilter();
		if (andClose) {
			vm.closeFn();
		}
	}

	function saveAsDefaultFilter() {
		if (!vm.query.navigationItem || !vm.query.showInNavigation) {
			return;
		}

		if (vm.isDefault) {
			personalizationService.setDefaultFilterForNavItem(vm.query.navigationItem, vm.query.id);
		} else {
			personalizationService.getDefaultFilterForNavItem(vm.query.navigationItem).then((queryId) => {
				if (queryId === vm.query.id) {
					personalizationService.setDefaultFilterForNavItem(vm.query.navigationItem);
				}
			});
		}
	}

	function initIsDefault() {
		if (!vm.query.navigationItem || !vm.query.showInNavigation) {
			return;
		}
		personalizationService.getDefaultFilterForNavItem(vm.query.navigationItem).then((queryId) => {
			vm.isDefault = queryId === vm.query.id;
		});
	}

	function validateQueryBuilder() {
		const queryBuilderValid = vm.query && vm.query.title.length > 0 && searchQueryService.validateGroup(vm.query.group);

		if (!queryBuilderValid) {
			notificationService.confirm(
				i18n.get('solutionBuilderAgent.components.mx-search-query-builder.invalidConditions'),
				i18n.get('solutionBuilderAgent.components.mx-search-query-builder.defineConditionsMsg'),
				i18n.get('shell.common.ok')
			);
		}

		return queryBuilderValid;
	}

	function _fillActions() {
		if (vm.query.dataQuery && vm.canEdit) {
			const deleteAction = new mx.shell.Action('delete_filter', i18n.get('solutionBuilderAgent.components.mx-search-query-builder.delete'), 'delete');

			deleteAction.controller = function () {
				return {
					execute: function () {
						searchQueryService.deleteFilter(vm.query).then((succeded) => {
							if (succeded) {
								vm.closeFn();
							}
						});
					},
				};
			};

			vm.actions.push(deleteAction);

			const addChildAction = new mx.shell.Action('add_child_filter', i18n.get('solutionBuilderAgent.components.mx-search-query-builder.addChild'), 'device_hub');

			addChildAction.controller = function () {
				return {
					execute: function () {
						searchQueryService.addChildFilter(vm.query);
					},
				};
			};

			vm.actions.push(addChildAction);
		}
	}

	function clearInvalidConditions(group) {
		if (group.conditions) {
			_.remove(group.conditions, (c) => !c.__valid);
		}

		(group.groups || []).forEach((group) => {
			clearInvalidConditions(group);
		});
	}
}
